import * as angular from "angular";
import {IController, ILogService} from "angular";
import {ServiceType} from "../../../deliveries/types/service.type";
import {HolderType} from "../../../commons/types/holder.type";
import * as _ from "lodash"
import {DocumentSettings} from "../../models/document-settings.model";
import {ReminderSettings} from "../../models/reminder-settings.model";
import {VehicleStatusChangeReasonSettingsEntity} from "../../models/vehicle-status-change-reason-settings.model";
import {
  VehicleStatusChangeReasonsDialogsService
} from "../../services/vehicle-status-change-reasons-dialogs-service.service";
import {DocumentsDialogsService} from "../../services/documents-dialogs-service.service";
import {RemindersDialogsService} from "../../services/reminders-dialogs-service.service";
import {SettingsService} from "../../services/settings-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class VehiclesPreferencesTabCtrl implements IController {
  documents: DocumentSettings[];
  reminders: ReminderSettings[];
  statusChangeReasons: VehicleStatusChangeReasonSettingsEntity[];

  public serviceTypes: ServiceType[];

  public tabs: any;
  private selectedTab: any;

  constructor(private documentsDialogsService: DocumentsDialogsService, private remindersDialogsService: RemindersDialogsService, private $log: ILogService,
              private confirmDialogService: ConfirmDialogService, private vehicleStatusChangeReasonsDialogsService: VehicleStatusChangeReasonsDialogsService, private settingsService: SettingsService, private IAMPermissions) {

  }

  $onInit() {
    this.tabs = _.filter(['Configuration', 'Vehicles Types'], (t) => {
      return t === 'Configuration' ?
        this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.list') :
        this.IAMPermissions.hasPermission('fleetManagement.vehicles.list')
    })
    this.selectedTab = 0; // 0 = General, 1 = Additions
  }

  // ******************************
  //        Public Methods
  // ******************************

  onTabSelect(selectedTab) {
    this.selectedTab = selectedTab;
  }

  ////////////////////////////////////// DOCUMENTS //////////////////////////////////////

  onCreateDocument(event) {
    this.documentsDialogsService.createDocument(event, HolderType.VEHICLE)
      .then(({document}) => {
        return this.settingsService.createDocument(document)
      })
      .then((createdDocument) => {
        this.documents.push(createdDocument);
      })
      .catch(() => {
        this.$log.info('Failed to create document')
      })
  }

  onEditDocument(event, documentId) {
    const document = _.find(this.documents, (doc) => {
      return doc.id === documentId;
    })
    const documentCopy = angular.copy(document)
    this.documentsDialogsService.editDocument(event, documentCopy)
      .then(({document}) => {
        return this.settingsService.updateDocument(document)
      })
      .then((updatedDocument) => {
        const index = _.findIndex(this.documents, {id: documentId});
        this.documents.splice(index, 1, updatedDocument);
      })
      .catch(() => {
        this.$log.info('Failed to edit document')
      })
  }

  onDeleteDocument(event, document) {
    const title = 'Delete Document';
    const body = 'Are you sure you want to delete this document?';

    this.confirmDialogService.confirm(title, body, event)
      .then(() => {
        const documentCopy = angular.copy(document);
        return this.settingsService.deleteDocument(documentCopy)
      })
      .then(() => {
        const index = _.findIndex(this.documents, {id: document.id})
        this.documents.splice(index, 1);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  ////////////////////////////////////// REMINDERS //////////////////////////////////////


  onCreateReminder(event) {
    this.remindersDialogsService.createReminder(event, HolderType.VEHICLE)
      .then(({reminder}) => {
        return this.settingsService.createReminder(reminder)
      })
      .then((createdReminder) => {
        this.reminders.push(createdReminder);
      })
      .catch(() => {
        this.$log.info('Failed to create reminder')
      })
  }

  onEditReminder(event, reminderId) {
    const reminder = _.find(this.reminders, (rem) => {
      return rem.id === reminderId;
    })
    const reminderCopy = angular.copy(reminder)
    this.remindersDialogsService.editReminder(event, reminderCopy)
      .then(({reminder}) => {
        return this.settingsService.updateReminder(reminder)
      })
      .then((updatedReminder) => {
        const index = _.findIndex(this.reminders, {id: reminderId});
        this.reminders.splice(index, 1, updatedReminder);
      })
      .catch(() => {
        this.$log.info('Failed to edit reminder')
      })
  }

  onDeleteReminder(event, reminder) {
    const title = 'Delete reminder';
    const body = 'Are you sure you want to delete this reminder?';

    this.confirmDialogService.confirm(title, body, event)
      .then(() => {
        const reminderCopy = angular.copy(reminder);
        return this.settingsService.deleteReminder(reminderCopy)
      })
      .then(() => {
        const index = _.findIndex(this.reminders, {id: reminder.id})
        this.reminders.splice(index, 1);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  ///////////////// Status Changes Reasons////////////////////

  onCreateStatusChangesReason(event) {
    this.vehicleStatusChangeReasonsDialogsService.createVehicleStatusChangeReason(event)
      .then(({vehicleStatusChangeReason}) => {
        return this.settingsService.createVehicleStatusChangeReason(vehicleStatusChangeReason)
      })
      .then((createdVehicleStatusChangeReason) => {
        this.statusChangeReasons.push(createdVehicleStatusChangeReason);
      })
      .catch(() => {
        this.$log.info('Failed to create vehicle status change reason')
      })
  }

  onEditStatusChangesReason(event, statusChangeReasonId:string) {
    const statusChangeReason = _.find(this.statusChangeReasons, (scr) => {
      return scr.id === statusChangeReasonId;
    })
    const statusChangeReasonCopy = angular.copy(statusChangeReason)
    this.vehicleStatusChangeReasonsDialogsService.editVehicleStatusChangeReason(event, statusChangeReasonCopy)
      .then(({vehicleStatusChangeReason}) => {
        return this.settingsService.updateVehicleStatusChangeReason(vehicleStatusChangeReason)
      })
      .then((updatedVehicleStatusChangeReason) => {
        const index = _.findIndex(this.statusChangeReasons, {id: statusChangeReasonId});
        this.statusChangeReasons.splice(index, 1, updatedVehicleStatusChangeReason);
      })
      .catch(() => {
        this.$log.info('Failed to edit Vehicle Status Change Reason')
      })
  }

  onDeleteStatusChangesReason(event, statusChangesReason:VehicleStatusChangeReasonSettingsEntity) {
    const title = 'Delete Status Change Reason';
    const body = 'Are you sure you want to delete this Status Change Reason?';

    this.confirmDialogService.confirm(title, body, event)
      .then(() => {
        const statusChangesReasonCopy = angular.copy(statusChangesReason);
        return this.settingsService.deleteVehicleStatusChangeReason(statusChangesReasonCopy)
      })
      .then(() => {
        const index = _.findIndex(this.statusChangeReasons, {id: statusChangesReason.id})
        this.statusChangeReasons.splice(index, 1);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('vehiclesPreferencesTab', {
    bindings: {
      documents: '<',
      reminders: '<',
      statusChangeReasons: '<',
    },
    template: require('./vehicles-preferences-tab.html').default,
    controller: VehiclesPreferencesTabCtrl
  });
